import React, { useEffect, useState } from 'react';

const PaymentAlert = ({ message, type, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        onClose();
      }, 3000); // Message visible for 3 seconds
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!isVisible) return null;

  const bgColor = type === 'success' ? 'bg-green-500' : 'bg-red-500';
  const textColor = 'text-white';
  const animationClass = isVisible ? 'animate-fade-in' : 'animate-fade-out';

  return (
    <div
      className={`fixed top-5 left-1/2 -translate-x-1/2 p-4 rounded-lg shadow-lg ${bgColor} ${textColor} ${animationClass}`}
      style={{ zIndex: 1000 }}
    >
      <p className="text-lg font-semibold">{message}</p>
    </div>
  );
};

export default PaymentAlert;